import * as React from "react";
import * as kea from "kea-react";
import * as models from "app/models/requireme";
import { FolioPPModal } from "./listado";
import { createSelector } from "keautils";
import { fa } from "typed-font-awesome";


interface Props {
    value: string;
    tipoServicio: models.TipoServicio;
    onChange: (x: string) => void;
    error: Promise<string | undefined> | string | undefined;
    label: string;
    session: models.Session | null;
    
}

export class FolioGuiaPP extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();

    onMostrarModal = async () => {
        const ret = await this.modalManager.showModal(FolioPPModal, {session:this.props.session}, {session:this.props.session});
        if (ret.result != null) {
            this.props.onChange(ret.result);
        }
    }

    value = (x: Props) => x.value;

    render() {
        return (
            <div>
                <kea.Text
                    addon={
                    <kea.Link onClick={this.onMostrarModal} iconClass={fa("search")} />
                    }
                    {
                        ... this.props
                    }
                />
                {this.modalManager.component}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/guiapp/index.tsx